/**
 * 认证服务
 * 职责：封装认证相关的API请求，包括登录、注册、用户信息等
 *
 * 统一调用规范：
 * - 所有接口通过 user 后端调用
 * - 统一使用 api.js (axios实例)
 *
 * API 路径规范：
 * - 认证接口：/api/v1/auth/*
 * - 用户接口：/api/v1/user/*
 */
import api from './api';

const authService = {
  // ==================== 登录注册相关 ====================

  /**
   * 用户登录
   * POST /api/v1/auth/login
   */
  login: (credentials) => {
    return api.post('/api/v1/auth/login', credentials);
  },

  /**
   * 用户注册
   * POST /api/v1/auth/register
   */
  register: (userData) => {
    return api.post('/api/v1/auth/register', userData);
  },

  /**
   * 发送短信验证码（包含风险控制和人机验证）
   * POST /api/v1/auth/send-code
   */
  sendVerificationCode: (phone, purpose, captchaToken) => {
    return api.post('/api/v1/auth/send-code', {
      phone,
      purpose,
      captchaToken
    });
  },

  /**
   * 验证短信验证码
   *
   * P0-7：公开的 /api/v1/auth/verify-code 预言机端点已下线（可被无限试探
   * 验证码正确性）。短信验证码由业务端点服务端强制校验：
   * - 注册：POST /api/v1/auth/register（register.verificationCode）
   * - 重置密码：POST /api/v1/auth/reset-password
   */

  /**
   * 重置密码
   * POST /api/v1/auth/reset-password
   */
  resetPassword: (data) => {
    return api.post('/api/v1/auth/reset-password', data);
  },

  // ==================== 用户信息相关 ====================

  /**
   * 获取当前用户信息
   * GET /api/v1/user/current
   */
  getUserInfo: () => {
    return api.get('/api/v1/user/current');
  },

  /**
   * 修改密码
   * POST /api/v1/user/change-password
   */
  changePassword: (oldPassword, newPassword) => {
    return api.post('/api/v1/user/change-password', null, {
      params: {
        oldPassword,
        newPassword
      }
    });
  },

  // ==================== Token 管理 ====================

  /**
   * 刷新token
   * POST /api/v1/auth/refresh-token
   */
  refreshToken: () => {
    return api.post('/api/v1/auth/refresh-token');
  },

  /**
   * 用户登出
   * POST /api/v1/auth/logout
   */
  logout: () => {
    return api.post('/api/v1/auth/logout');
  },

  // ==================== 业务相关 ====================

  /**
   * 获取企业认证列表
   * GET /api/v1/verification/enterprise/list
   */
  getEnterpriseVerificationList: () => {
    return api.get('/api/v1/verification/enterprise/list');
  },
};

// 导出单独的函数供组件使用
export const {
  login,
  register,
  sendVerificationCode,
  resetPassword,
  getUserInfo,
  changePassword,
  refreshToken,
  logout,
  getEnterpriseVerificationList,
} = authService;

// 导出默认服务
export default authService;
